import React, { useState } from "react";
import { useWorkingFilter } from "hooks/use-working-filter";
import SizeSelector from "./size-selector";
import PlusIcon from "images/sprites/reb/svg/plus-icon.svg";
import MinusIcon from "images/sprites/reb/svg/minus-icon.svg";
import type { CanonicalSize } from "components/types/canonical-size";
import { isActiveMembership, isClassicLens } from "helpers/membership-helpers";
import { useAppSelector } from "../../../../../util/store-types";
import HeapHelpers from "helpers/heap-helpers";

export type GridFilterSizeSelectorProps = {
  onSubmitFilters: () => void;
};

const GridFilterSizeSelector = ({ onSubmitFilters }: GridFilterSizeSelectorProps) => {
  const isProspect = useAppSelector(state => !isActiveMembership(state.membershipState));
  const hasSubscriptionIntent = useAppSelector(state => !isClassicLens(state.userData));
  const fireHeapEvent = (sizes: CanonicalSize[] = []) => {
    const heapEventData = {
      sizes: sizes.join(","),
      isProspectWithSubscriptionIntent: isProspect && hasSubscriptionIntent,
    };

    HeapHelpers.fireHeapEvent("size_select", heapEventData);
  };

  const onChangeSizeFilter = (sizes?: CanonicalSize[]) => {
    fireHeapEvent(sizes);
    onSubmitFilters();
  };

  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);
  const [selectedSizes = [], setSelectedSizes] = useWorkingFilter("canonicalSizes", onChangeSizeFilter);

  const sizeAnnotation = selectedSizes.length
    ? [...selectedSizes].sort((a, b) => parseInt(a) - parseInt(b)).join(", ")
    : "";

  const renderIcon = () => {
    return isOpen ? <MinusIcon /> : <PlusIcon />;
  };

  const renderSizeSelector = () => {
    if (!isOpen) {
      return null;
    }

    return (
      <div className="flex flex-wrap my-2">
        <SizeSelector setSelectedSizes={setSelectedSizes} selectedSizes={selectedSizes} />
      </div>
    );
  };

  return (
    <div className="my-2">
      <div className="flex justify-between">
        <div>My sizes</div>
        <div className="flex justify-between items-end gap-4">
          <p className="text-darkGray text-sm">{sizeAnnotation}</p>
          <button data-test-id="size-selector-toggle" onClick={toggleOpen}>
            {renderIcon()}
          </button>
        </div>
      </div>
      {renderSizeSelector()}
    </div>
  );
};

export default GridFilterSizeSelector;
